import React from "react";
import Translate from "react-translate-component";
import BindToChainState from "../../Utility/BindToChainState";
import utils from "common/utils";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const BalanceClaim = ({
  op,
  changeColor,
  linkToAccount,
  fromComponent
}) => {
  changeColor("success");
  op[1].total_claimed.amount = parseInt(op[1].total_claimed.amount, 10);

  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].deposit_to_account), "\xA0", /*#__PURE__*/React.createElement(BindToChainState.Wrapper, {
      asset: op[1].total_claimed.asset_id
    }, ({
      asset
    }) => /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.balance_claim",
      balance_amount: utils.format_asset(op[1].total_claimed.amount, asset),
      balance_id: op[1].balance_to_claim.substring(5)
    })));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.balance_claim",
      keys: [{
        type: "account",
        value: op[1].deposit_to_account,
        arg: "account"
      }, {
        type: "amount",
        value: op[1].total_claimed,
        arg: "amount"
      }]
    }));
  }
};